import { Grid, GridColumn } from '@atlaskit/page';
import { inject, observer } from 'mobx-react';
import React from 'react';
import ReactFocusLock from 'react-focus-lock';
import ReactScrollLock, { TouchScrollable } from 'react-scrolllock';
import styled from 'styled-components';

import Store from '../store';
import BlanketStore, { BlanketBody } from '../store/blanketStore';

import { onDesktop, onMobile } from './mobile/responsive';
import ProductScreen from './Products/ProductScreen';
import { FadeIn } from './styled/animations';

const blanketStyles: React.CSSProperties = {
  width: '100vw',
  height: '100vh',
  backgroundColor: 'white',
  overflowY: 'auto',
  transition: 'opacity 0.25s ease-out',
  position: 'fixed',
  zIndex: 4,
  pointerEvents: 'none',
  opacity: 0,
};

const Body = styled.div`
  width: 100%;
  ${onDesktop(`
    padding: 40px 0 0 0;
  `)}

  ${onMobile(`
    padding: 60px 0 0 0;
  `)}
`;

interface Props {
  blanketStore: BlanketStore;
}

@observer
class Blanket extends React.Component<Props> {
  componentDidMount() {
    addEventListener('keydown', this.onEscape);
  }

  componentWillUnmount() {
    removeEventListener('keydown', this.onEscape);
  }

  render() {
    const { body } = this.props.blanketStore;
    const shouldShow = body !== BlanketBody.None;
    // TouchScrollable for some reason doesn't work if its child is a styled component
    // so we are using inline styles
    return (
      <TouchScrollable>
        <div style={{ ...blanketStyles, ...(shouldShow ? { opacity: 1, pointerEvents: 'all' } : {}) }}>
          <ReactFocusLock disabled={!shouldShow}>
            <FadeIn>
              <Body>
                <Grid columns={16}>
                  <GridColumn key="blanket-content" medium={16}>
                    {body === BlanketBody.Products && <ProductScreen />}
                  </GridColumn>
                </Grid>
              </Body>
            </FadeIn>
          </ReactFocusLock>
          <ReactScrollLock isActive={shouldShow} />
        </div>
      </TouchScrollable>
    );
  }

  private onEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.props.blanketStore.hideBlanket();
    }
  };
}

export default inject(({ blanketStore }: Store) => ({
  blanketStore,
}))(Blanket);
